module.exports = __webpack_public_path__ + "media/lightWait.bfc61a4e.mp3";